/**
 * @generated SignedSource<<3e37559f4b3ee95b4db9082706712eff>>
 * @relayHash 0e3174f62d9c6a038178e4651e6b1bd4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 45a739f509c8ad6d12d0812df8dc4c41133bcb1eb852775729851a9653db600d

import type { ConcreteRequest } from 'relay-runtime';
export type WorkflowsLimitsBannerQuery$variables = {
  cloudId: string;
  filterKeys: ReadonlyArray<string>;
};
export type WorkflowsLimitsBannerQuery$data = {
  readonly jira: {
    readonly limitValues: ReadonlyArray<{
      readonly key: string | null;
      readonly limitValue: number | null;
    } | null> | null;
  } | null;
};
export type WorkflowsLimitsBannerQuery = {
  response: WorkflowsLimitsBannerQuery$data;
  variables: WorkflowsLimitsBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterKeys"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "filterKeys",
            "variableName": "filterKeys"
          }
        ],
        "concreteType": "JiraResourceUsageMetricLimitValue",
        "kind": "LinkedField",
        "name": "limitValues",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "limitValue"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WorkflowsLimitsBannerQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkflowsLimitsBannerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "45a739f509c8ad6d12d0812df8dc4c41133bcb1eb852775729851a9653db600d",
    "metadata": {},
    "name": "WorkflowsLimitsBannerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c63ef016969748d4137d437200a12425";

export default node;
